// src/ChevronDownIcon.tsx
import { jsx } from "react/jsx-runtime";
var ChevronDownIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "m6 9 6 6 6-6" })
  }
);
var ChevronDownIcon_default = ChevronDownIcon;

export {
  ChevronDownIcon_default
};
